// extracted by mini-css-extract-plugin
export var actionButton = "_jd-t";
export var buttonContainer = "_jd-0";
export var buttonContainer2 = "_jd-1";
export var buttonSection = "_jd-2";
export var details = "_jd-3";
export var dropdownItem = "_jd-5";
export var dropdownItemsContainer = "_jd-4";
export var fileInput = "_jd-r";
export var headerButton = "_jd-6";
export var icon = "_jd-7";
export var input = "_jd-8";
export var macroListItem = "_jd-9";
export var mainContent = "_jd-a";
export var microText = "_jd-b";
export var modal = "_jd-w";
export var optionsButton = "_jd-c";
export var paperclip = "_jd-s";
export var pillContent = "_jd-d";
export var preview = "_jd-e";
export var preview2 = "_jd-f";
export var quillEditor = "_jd-q";
export var selectedMacro = "_jd-g";
export var sidebar = "_jd-h";
export var sidebarHeader = "_jd-j";
export var sidebarList = "_jd-i";
export var sidebarListItem = "_jd-k";
export var sidebarSearch = "_jd-l";
export var snoozeDurationWrapper = "_jd-v";
export var statusPillContainer = "_jd-m";
export var tagsContainer = "_jd-n";
export var unselectedMacro = "_jd-o";
export var variable = "_jd-u";
export var wrapper = "_jd-p";